import * as palette from "@govlaunch/palette";
import * as queryString from "query-string";

import EditorBlockHandling from "../EditorBlockHandling";
import { Hover } from "react-powerplug";
import PropTypes from "prop-types";
import React from "react";
import { clamp } from "lodash";
import { css } from "@emotion/css";

export default function GoogleSpreadsheet({ block, blockProps }) {
  const blockData = block.getData();

  const spreadsheetUrl = blockData.get("src");
  const adjustedSize = blockData.get("adjustedSize");
  const displayHeaders = blockData.get("displayHeaders");

  const normalizedUrl = spreadsheetUrl.replace("&amp;", "&");
  const parsed = queryString.parseUrl(normalizedUrl);

  let options = {};

  if (!displayHeaders) {
    options = {
      ...options,
      widget: false,
      chrome: false,
    };
  }

  const embedQuery = queryString.stringify({
    ...options,
    embedded: true,
  });

  const embedUrl = `${parsed.url.replace("/pubhtml", "/pub")}?${embedQuery}`;

  return (
    <EditorBlockHandling editorState={blockProps.editorState} onChange={blockProps.onChange}>
      {({ setBlockData, removeBlock }) => (
        <Hover>
          {({ bind }) =>
            blockProps.readOnly ? (
              <div
                css={{
                  paddingTop: 10,
                }}
              >
                <iframe
                  src={embedUrl}
                  frameBorder="0"
                  className={iframeClass}
                  style={{
                    height: adjustedSize || null,
                  }}
                />
              </div>
            ) : (
              <div
                {...bind}
                css={{
                  paddingBottom: 0,
                }}
              >
                <div
                  css={{
                    paddingTop: 10,
                    borderBottom: displayHeaders ? "none" : `solid 1px ${palette.lightSealBlue}`,
                  }}
                >
                  <div
                    css={{
                      marginBottom: displayHeaders ? 0 : 10,
                      display: "flex",
                      width: "100%",
                      userSelect: "none",
                      border: `solid 1px $palette.lightSealBlue}`,
                      borderRadius: 4,
                      borderBottomLeftRadius: displayHeaders ? 0 : 4,
                      borderBottomRightRadius: displayHeaders ? 0 : 4,
                      alignItems: "center",
                      padding: 20,
                    }}
                  >
                    <div
                      css={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        css={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <strong
                          css={{
                            fontWeight: 600,
                            fontSize: 16,
                          }}
                        >
                          Size
                        </strong>

                        <div
                          css={{
                            marginLeft: 5,
                          }}
                        >
                          <input
                            onFocus={() => blockProps.setReadOnly(true)}
                            onBlur={() => blockProps.setReadOnly(false)}
                            onChange={event => {
                              const size = parseInt(event.target.value);

                              if (size) {
                                setBlockData(block, {
                                  adjustedSize: clamp(size, 100, 800),
                                });
                              }
                            }}
                            placeholder="200"
                            css={{
                              outline: "none",
                              border: `solid 1px $palette.lightSealBlue}`,
                              borderRadius: 4,
                              type: "text",
                              padding: 5,
                              width: 60,
                              textAlign: "center",
                              fontSize: 14,
                            }}
                          />
                        </div>
                      </div>

                      <div
                        css={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: 10,
                        }}
                      >
                        <strong
                          css={{
                            fontWeight: 600,
                          }}
                        >
                          Headers?
                        </strong>

                        <div
                          css={{
                            marginLeft: 5,
                          }}
                        >
                          <input
                            type="checkbox"
                            onFocus={() => blockProps.setReadOnly(true)}
                            onBlur={() => blockProps.setReadOnly(false)}
                            defaultChecked={displayHeaders}
                            onChange={event => {
                              setBlockData(block, {
                                displayHeaders: event.target.checked,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <a
                      href="#"
                      css={{
                        textDecoration: "none",
                        color: palette.mediumGray,
                        marginLeft: "auto",
                        "&:hover": {
                          color: "#000",
                        },
                      }}
                      onClick={() => {
                        removeBlock(block);
                      }}
                    >
                      <TrashCan width={18} height={18} />
                    </a>
                  </div>

                  <iframe
                    src={embedUrl}
                    frameBorder="0"
                    className={iframeClass}
                    style={{
                      height: adjustedSize || null,
                    }}
                  />
                </div>
              </div>
            )
          }
        </Hover>
      )}
    </EditorBlockHandling>
  );
}

GoogleSpreadsheet.propTypes = {
  block: PropTypes.object.isRequired,
  blockProps: PropTypes.object.isRequired,
};

const iframeClass = css({
  width: "100%",
  height: 200,
});

const TrashCan = props => (
  <svg viewBox="0 0 459 459" width="1em" height="1em" {...props}>
    <path
      fill="currentColor"
      d="M76.5 408c0 28.05 22.95 51 51 51h204c28.05 0 51-22.95 51-51V102h-306v306zM408 25.5h-89.25L293.25 0h-127.5l-25.5 25.5H51v51h357v-51z"
    />
  </svg>
);
